import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Testimonials = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API}/testimonials`).then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <section
      id="recensioni"
      className="relative py-28 md:py-40 bg-[var(--pw-surface)] overflow-hidden"
      data-testid="testimonials-section"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-12 gap-12 mb-20 items-end">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-4 mb-6">
              <span className="gold-line" />
              <span className="overline">Recensioni</span>
            </div>
            <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-[var(--pw-text)]">
              <em className="text-[var(--pw-gold)]">Cinque</em> stelle.
              <br />Cento per cento delle coppie.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-3">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={18} className="text-[var(--pw-gold)]" fill="currentColor" />
              ))}
              <span className="font-serif italic text-2xl text-[var(--pw-text)] ml-2">
                5.0 / 5.0
              </span>
            </div>
            <p className="text-[var(--pw-text)]/60 font-light text-sm">
              Valutazione media su Matrimonio.com — recensioni verificate dalle coppie.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((t, i) => (
            <motion.div
              key={t.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="card-pw p-8 lg:p-10 flex flex-col"
              data-testid={`testimonial-${t.id}`}
            >
              <Quote
                size={28}
                className="text-[var(--pw-gold)]/60 mb-6"
                strokeWidth={1.2}
              />
              <h4 className="font-serif italic text-xl text-[var(--pw-gold)] mb-3">
                {t.title}
              </h4>
              <p className="text-[var(--pw-text)]/75 font-light text-[15px] leading-relaxed flex-1">
                "{t.text}"
              </p>
              <div className="mt-8 flex items-center justify-between border-t border-[var(--pw-border)] pt-5">
                <div>
                  <div className="text-[var(--pw-text)] font-medium tracking-wide">{t.name}</div>
                  <div className="text-[var(--pw-text)]/50 text-xs mt-1">{t.date}</div>
                </div>
                <div className="flex gap-1">
                  {[...Array(t.rating)].map((_, j) => (
                    <Star key={j} size={12} className="text-[var(--pw-gold)]" fill="currentColor" />
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
